module.exports = __webpack_public_path__ + "static/media/comentario.cfe6db26.svg";